import { webApiConfig } from '@/lib/api-config';

/** Same-origin path when a Lambda URL is configured (Vite dev proxy + Amplify rewrite). */
export async function resolveLambdaApiUrls(opts: {
  apiPath: string;
  customKey: string;
  viteEnvKey?: string;
}): Promise<{ proxyPath: string; directUrl: string } | null> {
  const fromEnv = opts.viteEnvKey
    ? (import.meta.env[opts.viteEnvKey] as string | undefined)
    : undefined;
  const remote =
    fromEnv?.trim() || (await webApiConfig.getCustomUrl(opts.customKey))?.trim() || null;
  if (!remote) return null;
  return {
    proxyPath: opts.apiPath,
    directUrl: remote.replace(/\/$/, ''),
  };
}
